import { SbsPlayerGlobal } from '../../common';
import { importScript } from '../../utils';
import { getUUID } from '../../utils/advertisements';

import SbsPlayerLogger from '../../utils/logger';

/**
 * SBS 추천 서비스 클라이언트 로그 모듈
 * 비디오 플레이어의 재생 이벤트와 사용자 상호작용을 추적하는 로깅 모듈
 */
class SbsLogModule {
  constructor() {
    this.cmdata = null;
    this.extra = null;
    this.state = {
      quality_changed: false,
      ended: false,
      isFirst: true,
    };
    this._event = {
      initialized: () => {
        console.log(`initialized.`);
      },
    };
  }

  get event() {
    return this._event;
  }
  set event(event) {
    this._event = event;
  }

  init(video) {
    try {
      this.video = video;

      const { info, source, ad, ad_25, ad_30, ad_sbs } =
        SbsPlayerGlobal.state.data;
      const smrAdVersion = (ad?.smr_ad_version || '2.5').replace(/\./g, '');
      const ad_smr = smrAdVersion === '25' ? ad_25 : ad_30;

      // ! 골프 API에 관련데이터 없을 경우 그냥 예외처리
      if (!ad_smr) {
        this._event.initialized();
        return null;
      }
      const vodType =
        SbsPlayerGlobal.target === 'live'
          ? 'O'
          : info.type.toUpperCase() === 'VOD' ||
            info.type.toUpperCase() === 'VOD3MIN' ||
            info.group?.toUpperCase() === 'VOD'
          ? 'F'
          : 'C';
      console.log('==> vodType', vodType);

      this.uuid = getUUID(ad_smr);
      this.cmdata = ad_smr.cmdata;
      this.extra = {
        logtype: `${this.state.quality_changed ? 'DT' : 'QC'}`,
        duration: parseInt(video.currentTime),
        playertype: 'HTML5',
        productcode: info.productcode,
        vodtype: vodType,
        fullvodtype: info.fullvodtype,
        mode:
          info.type === 'VOD3MIN' ||
          info.onair_preview_yn === 'Y' ||
          info.preview_yn === 'Y'
            ? 'PSP'
            : 'FSP',
        sn_log: false,
        sn_article: '',
        title: info.title || '',
        program: info.program || null,
        content: info.content || null,
      };
      this.quality = {
        '02': 'SD',
        '05': 'HD',
        '07': 'FHD',
        '09': 'UHD',
      }[source.mediasource.mediarscuse];

      if (typeof SBSlogModule === 'undefined') {
        importScript(SbsPlayerGlobal.url.lib.sbs_video_log, () => {
          this._event.initialized();
        });
      } else {
        this._event.initialized();
      }
    } catch (error) {
      console.error(error);
    }
  }

  /**
   * SBS 로그 모듈 - 클릭 이벤트 추적
   * @param {String} clickName - 클릭 대상 (플레이어/CLIP/SBSAPP버튼 등)
   * @param {String} clickType - 클릭 타입 (NC 등)
   * @param {String} value1 - 추가 정보 1 (재생 상태 등)
   * @param {String} value2 - 추가 정보 2 (프로그램명 등)
   * @param {String} value3 - 추가 정보 3
   * @param {String} value4 - 추가 정보 4
   * @param {String} value5 - 추가 정보 5
   */
  click(clickName, clickType, value1, value2, value3, value4, value5) {
    try {
      console.log('==> click.', clickName, clickType);

      if (this.state.isFirst && clickName === '플레이어') {
        this.state.isFirst = false;
      } else if (!this.state.isFirst) {
        //value1 = '재생중';
      }

      if (clickName && clickType) {
        clickType = clickType.toUpperCase();
        value1 ??= '';
        value2 ??= '';
        value3 ??= '';
        value4 ??= '';
        value5 ??= '';

        window.__SBSLogModuleDataLayer = window.__SBSLogModuleDataLayer || [];
        window.__SBSLogModuleDataLayer.push({
          type: 'click',
          option: {
            clickName: clickName,
            clickType: clickType,
            value1: value1, // optional
            value2: value2, // optional
            value3: value3, // optional
            value4: value4, // optional
            value5: value5, // optional
          },
        });
      }
    } catch (error) {
      console.error('__SBSLogModuleDataLayer', error);
    }
  }
  /**
   * SBS 로그 모듈 - 광고 재생 이벤트
   * @param {String} adType - 광고 타입 (필수) - SBS, SMR, ADX, XC
   * @param {String} adPosition - 광고 위치 (필수) - prerollplus, preroll, midroll, postroll
   */
  adPlay(adType, adPosition) {
    try {
      console.log('==> adPlay.', adType, adPosition);

      const { info } = SbsPlayerGlobal.state.data;
      const playMode =
        info.type === 'VOD3MIN' ||
        info.onair_preview_yn === 'Y' ||
        info.preview_yn === 'Y'
          ? 'PR'
          : 'NR';

      if (adType && adPosition) {
        adType = adType.toUpperCase();
        adPosition = adPosition === 'live_midroll' ? 'midroll' : adPosition;
        //let ifaValue = adType === 'SBS' ?

        window.__SBSLogModuleDataLayer = window.__SBSLogModuleDataLayer || [];
        window.__SBSLogModuleDataLayer.push({
          type: 'adPlay',
          option: {
            cmdata: this.cmdata, //Require
            extra: this.extra, //Require
            playMode: playMode, //재생 모드(별도 표 참조)
            adType: adType, //광고 타입 (Require), SBS, SMR, ADX, XC
            adPosition: adPosition, //광고 위치(Require) prerollplus, preroll, midroll, postroll
            ifa: adType === 'SBS' || adType === 'SMR' ? this.uuid : '', //광고 식별자 (별도 표 참조)
          },
        });
      }
    } catch (error) {
      console.error('__SBSLogModuleDataLayer', error);
    }
  }

  /**
   * SBS 로그 모듈 - 콘텐츠 재생 시작
   * 온에어/VOD/클립 모든 콘텐츠 재생 시작시 호출
   */
  contentPlay() {
    try {
      this.state.quality_changed = true;
      this.state.ended = false;

      const { info } = SbsPlayerGlobal.state.data;
      const playMode = SbsPlayerGlobal.state.dvr
        ? 'TM'
        : info.type === 'VOD3MIN' ||
          info.onair_preview_yn === 'Y' ||
          info.preview_yn === 'Y'
        ? 'PR'
        : 'NR';

      const playContinue = info.playduration ? true : false;
      console.log('==> contentPlay');
      window.__SBSLogModuleDataLayer = window.__SBSLogModuleDataLayer || [];
      window.__SBSLogModuleDataLayer.push({
        type: 'contentPlay',
        option: {
          cmdata: this.cmdata,
          extra: this.extra,
          playMode: playMode, //재생 모드(별도 표 참조)
          playQuality: this.quality, //재생 화질(별도 표 참조)
          playContinue: playContinue, //클립, 라이브 false 고정, VOD 이어보기시 true, 아니면 false
        },
      });
    } catch (error) {
      console.error('__SBSLogModuleDataLayer', error);
    }
  }

  /**
   * SBS 로그 모듈 - 콘텐츠 재생 중 상태 추적
   * @param {String} playMode - 재생 모드 (NR: 일반, PR: 미리보기, TM: 타임머신/DVR)
   * @param {Boolean} playContinue - 이어보기 여부 (클립/라이브: false, VOD 이어보기: true)
   * @param {Number} playDuration - 전체 재생시간(초), 라이브는 0
   * @param {Object} videoElement - 비디오 엘리먼트 (온에어시 null)
   * @param {Number} countInterval - 시청시간 카운트 인터벌(분)
   */
  contentPlaying(
    playMode,
    playContinue,
    playDuration,
    videoElement,
    countInterval
  ) {
    try {
      if (!this.state.ended) {
        // 온에어일 경우 videoElement는 null로 처리
        const playTime = videoElement ? parseInt(videoElement.currentTime) : -1;
        console.log(
          '==> contentPlaying',
          playMode,
          playContinue,
          playDuration,
          playTime,
          countInterval
        );
        window.__SBSLogModuleDataLayer = window.__SBSLogModuleDataLayer || [];
        window.__SBSLogModuleDataLayer.push({
          type: 'contentPlaying',
          option: {
            cmdata: this.cmdata, //Require
            extra: this.extra, //Require
            playMode: playMode, //재생 모드(별도 표 참조)
            playScreenMode: SbsPlayerGlobal.state.fullscreen ? 'LS' : 'PO',
            playQuality: this.quality, //재생 화질(별도 표 참조)
            playContinue: playContinue, //클립, 라이브 false 고정, VOD 이어보기시 true, 아니면 false
            playDuration: playDuration, //전체 재생시간(초), 라이브는 0 고정
            playTime: playTime, //재생시간 (초)
            playViewTime: countInterval * 60, //시청시간(초)
          },
        });
      }
    } catch (error) {
      console.error('__SBSLogModuleDataLayer', error);
    }
  }

  /**
   * SBS 로그 모듈 - 콘텐츠 재생 종료
   * 콘텐츠 재생이 완료되었을 때 호출
   */
  contentPlayEnd() {
    try {
      if (!this.state.ended) {
        this.state.ended = true;

        console.log('==> contentPlayEnd');
        window.__SBSLogModuleDataLayer = window.__SBSLogModuleDataLayer || [];
        window.__SBSLogModuleDataLayer.push({
          type: 'contentPlayEnd',
          option: {
            cmdata: this.cmdata, //Require
            extra: this.extra, //Require
          },
        });
      }
    } catch (error) {
      console.error('__SBSLogModuleDataLayer', error);
    }
  }

  /**
   * SBS 로그 모듈 - 일반 클릭 이벤트
   * @param {String} label - 클릭 라벨
   * @deprecated 현재 구현에 버그가 있음 (contentPlayEnd 타입 사용)
   */
  normalClick(label) {
    try {
      console.log('==> connormalClicktentPlayEnd');

      window.__SBSLogModuleDataLayer = window.__SBSLogModuleDataLayer || [];
      window.__SBSLogModuleDataLayer.push({
        type: 'contentPlayEnd',
        option: {
          cmdata: this.cmdata, //Require
          extra: this.extra, //Require
        },
      });
    } catch (error) {
      console.error('__SBSLogModuleDataLayer', error);
    }
  }
}

export default SbsLogModule;
